import * as React from "react";
import Tag from "../../../../generic/tag";
import { FTChipColorKeyComb, FTScrollStyle } from "../../ftConstants";
import { EdLinkButton } from "../../../../generic/edButton";
import { IcommLimits, IftTransHistObj } from "../../../../types/components/fundTransfer/ftTypes";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import { toINR } from "../../../../service/numberFormat";

export interface IFtHistoryTblPayOutDeskProps {
	data: Array<any>;
	lim: string | IcommLimits;
	asset: string; //acctype either EQ or CO
}

const FtHistoryTblPayOutDesk: React.FC<IFtHistoryTblPayOutDeskProps> = (props) => {
	// isAccordianOpen = if row is open then it stores rowIndex otherwise -1
	const [isAccordianOpen, setIsAccordianOpen] = React.useState<number>();

	// used to open/close tab
	function toggleTab(index: number) {
		if (isAccordianOpen === index) {
			setIsAccordianOpen(undefined);
		} else {
			setIsAccordianOpen(index);
		}
	}

	return (
		<div className="ft_hist_table">
			<ul
				className={"ft_his_data " + (props.data.length > 0 ? "ftScrollCont" : "")}
				style={FTScrollStyle(props.data.length > 0 ? true : false)}
			>
				{props.data.map((row: IftTransHistObj, index) => {
					const limit =
						typeof props.lim === "string"
							? parseFloat(props.lim) + parseFloat(row.trnsAmt)
							: parseFloat(props.lim.lmAvl) + parseFloat(props.lim.poAmt);
					return row.sts.toLowerCase() === "payout pending" ? (
						<li className="fl_pend_row" key={index}>
							<div className="fl_pend_data">
								<div className="dt_time_sec">
									<div className="pending_sts">
										<i className="edel-icon-clock ft_clock"></i>Request Received
									</div>
									<div className="col date_time">
										<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
										<label> {moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY")}</label>
									</div>
								</div>
								<div className="bank_dtl_row">
									<div className="bank_dtl_sec">
										<div className="col bank">{row.bnkName}</div>
										<div className="col amount">₹{toINR(row.trnsAmt)}</div>
										<div className="col comment">
											<i className="edel-icon-comment"></i>
											<div className="comment_box">
												<label className="comment_tit">Your comments</label>
												<label className="comment_txt">{row.rmk}</label>
											</div>
										</div>
									</div>
									<div className="cta_sec">
										<EdLinkButton
											value="Edit Amount"
											btnTyp="link"
											className="cta"
											LinkHref={
												"../../withdraw-funds/edit?edit=" + JSON.stringify({ ...row, lim: limit, accType: props.asset })
											}
										/>
										<EdLinkButton
											value="Cancel Transfer"
											btnTyp="link"
											className="cta"
											LinkHref={"../../withdraw-funds/cancel?cancel=" + JSON.stringify({ ...row, accType: props.asset })}
										/>
									</div>
								</div>
								<div className="acc_sec">
									<div className="data_con">
										<label className="txt">Bank A/C</label>
										<label className="val">{row.bnkAccNo}</label>
									</div>
									<div className="data_con">
										<label className="txt">Ref No.</label>
										<label className="val">{row.instNo}</label>
									</div>
									{row.ldgrNm && (
										<div className="data_con">
											<label className="txt">Ledger</label>
											<label className="val">{row.ldgrNm}</label>
										</div>
									)}
								</div>
							</div>
						</li>
					) : (
						<li onClick={() => toggleTab(index)} className={"ft_his_row" + (isAccordianOpen === index ? " active" : "")} key={index}>
							<div className="fl_his fl_his_out">
								<div className="col date_time">
									<label className="tm">{moment(row.tm, ["h:mm A"]).format("HH:mm:ss")} </label>
									<label> {moment(dateTimeFormat(row.dt, " ")).format("DD MMM 'YYYY")}</label>
								</div>
								<div className="col bank bn_clr">{row.bnkName}</div>
								<div className="col amount bn_clr">₹{toINR(row.trnsAmt)}</div>
								<div className="col comment">
									<i className="edel-icon-comment"></i>
									<div className="comment_box">
										<label className="comment_tit">Your comments</label>
										<label className="comment_txt">{row.rmk}</label>
									</div>
								</div>
								<div className="col status">
									<Tag value={row.sts} shape="chip" color={FTChipColorKeyComb[row.sts.toLowerCase()]} />
								</div>
							</div>
							<div className="panel_txt">
								<div className="panel_data">
									<label className="txt">Bank A/C</label>
									<label className="val">{row.bnkAccNo}</label>
								</div>
								{row.payMd && (
									<div className="panel_data">
										<label className="txt">Mode</label>
										<label className="val">{row.payMd}</label>
									</div>
								)}
								{row.upi && (
									<div className="panel_data">
										<label className="txt">UPI ID</label>
										<label className="val">{row.upi}</label>
									</div>
								)}
								{row.ldgrNm && (
									<div className="panel_data">
										<label className="txt">Ledger</label>
										<label className="val">{row.ldgrNm}</label>
									</div>
								)}
								{row.refNo && (
									<div className="panel_data">
										<label className="txt">Ref No.</label>
										<label className="val">{row.refNo}</label>
									</div>
								)}
								{/* <div className="panel_data">
									<label className="txt">Reason</label>
									<label className="val">{row.rmk}</label>
								</div> */}
							</div>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default FtHistoryTblPayOutDesk;
